import { api_url } from "@/config/api_url";
import axios from 'axios';
import { defineStore } from "pinia";
import { useNotificationStore } from "./notificationStore";

export const useMissionStore = defineStore('missionStore',{
    state:() => ({
        missions:[],
        mission:[],
        possibleMissions:[],
        loading:false,
    }),

    actions:{
        async fetchMissions(){
            this.loading = true;
            axios.defaults.headers.common = {
                Authorization: `${localStorage.getItem('token')}`
            };
            try {
                const result = await axios.get(`${api_url}/admin/mission/getAll`);
                this.missions = result.data.data;
                this.loading = false;
            } catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async fetchMission(id){
            this.loading = true;
            try{
                const result = await axios.get(`${api_url}/admin/mission/${id}`);
                this.mission = result.data.data;
                this.loading = false;
            }catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async fetchMissionsWithVehicle(id){
            this.loading = true;
            try{
                const result = await axios.get(`${api_url}/admin/vehicle/${id}/missions`);
                this.missions = result.data.data;
                this.loading = false;
            }catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async fetchPossibleMissions(id){
            try{
                const result = await axios.get(`${api_url}/admin/vehicle/${id}/missions/getPossibleMissions`);
                this.possibleMissions = result.data.data;
                this.loading = false;
            }catch (error) {
                this.handleError(error);
                this.loading = false;
            }
        },

        async assingMission(missionToAdd,vehicleId){
            try {
                const response = await axios.put(`${api_url}/admin/vehicle/${vehicleId}/missions/${missionToAdd}`);
                this.missions = response.data.data;
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },


        async createMission(newMission) {
            try {
                newMission.owner = localStorage.getItem('userId');
                const response = await axios.post(`${api_url}/admin/mission`, newMission);
                this.missions = response.data.data;
                return response;
            } catch (error) {
                this.handleError(error.response.data);
            }
        },

        async editMission(editMission,id) {
            try {
                const response = await axios.put(`${api_url}/admin/mission/${id}`, editMission);
                this.mission = response.data.data;
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },

        async deleteMission(id){
            try {
                const response = await axios.delete(`${api_url}/admin/mission/${id}`);
                this.missions = response.data.data;  
                return response;
            } catch (error) {
                this.handleError(error);
            }
        },
        
        handleError(error) {
            useNotificationStore().setNotification('Error', error.message, 'mdi-alert', 'error');
        },
    }
})